/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMCarouselProductClickEvent } from '@/data/events/handlers/gtm/CarouselProductClick';
import { GTMCarouselProductClickPayload } from '@/data/types/GTM';

type CarouselProductClickDelegatorProps = {
	gtm?: GTMCarouselProductClickPayload;
};

export const carouselProductClickDelegator = async (
	payload: CarouselProductClickDelegatorProps
) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMCarouselProductClickEvent(gtm);
	}
};
